@if (activeMeeting(); as meeting) {
    <app-active-meeting
        [meeting]="meeting"
        [meetings]="grid.items"
        [pages]="activeMeetingPages()"
        (endMeeting)="handleEndMeeting()"
    ></app-active-meeting>
}

<div [hidden]="activeMeeting() || isInitialLoading">
    <div class="row page-header">
        <div class="col-12">
            <h1>Meetings <small>Manage meetings and view meeting metrics</small></h1>
        </div>
    </div>

    <div [hidden]="isInitialLoading">
        <div class="row">
            <div class="col-lg-12">
                <div class="row action-toolbar">
                    <div class="col-12">
                        <form class="form-inline">
                            <action-toolbar-count [grid]="grid"></action-toolbar-count>
                            <action-toolbar-buttons
                                [grid]="grid"
                                [canEdit]="canEdit"
                                [showAdd]="canViewAdmin"
                                [showEdit]="true"
                                [showDelete]="canViewAdmin"
                            ></action-toolbar-buttons>
                            <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                            <wj-combo-box
                                [hidden]="!canViewAdmin"
                                style="width: 140px"
                                [itemsSource]="boolList"
                                [displayMemberPath]="'display'"
                                [selectedValuePath]="'value'"
                                [(ngModel)]="userMeetings"
                                name="userMeetings"
                            ></wj-combo-box>
                        </form>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <wj-flex-grid
                            id="mainGrid"
                            #mainGrid
                            style="height: 255px"
                            (initialized)="grid.initialize(mainGrid)"
                            (destroy)="grid.destroy()"
                            [itemsSource]="grid.view"
                        >
                            <wj-flex-grid-filter></wj-flex-grid-filter>
                            <wj-flex-grid-column [header]="' '" [width]="90">
                                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                    <button
                                        class="btn btn-sm"
                                        [class.btn-secondary]="!isLive(cell.item)"
                                        [class.btn-success]="isLive(cell.item)"
                                        (click)="meet(cell.item)"
                                    >
                                        {{ isLive(cell.item) ? 'Join' : 'Meet' }}
                                    </button>
                                </ng-template>
                            </wj-flex-grid-column>
                            <wj-flex-grid-column [header]="'Status'" [binding]="'id'" [width]="70">
                                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                    @if (isLive(cell.item)) {
                                        <span class="badge bg-success">LIVE</span>
                                    }
                                </ng-template>
                            </wj-flex-grid-column>
                            <!-- <wj-flex-grid-column [header]="'Is Active'" [binding]="'isActive'" [width]="105"></wj-flex-grid-column> -->
                            <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                            <wj-flex-grid-column [header]="'Attendees'" [binding]="'userIds'" [width]="'2.5*'" [cssClass]="'cell-avatar'">
                                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                    @for (user of cell.item.users; track user.id) {
                                        @if (user.imageUrl && !user.showAlt) {
                                            <img
                                                [src]="user.imageUrl"
                                                [alt]="user.displayName"
                                                [title]="user.displayName"
                                                (error)="user.showAlt = true"
                                            />
                                        } @else {
                                            <div class="grid-row-avatar-no-img" [title]="user.displayName">
                                                {{ user.displayName.split(' ')[0][0] }}{{ user.displayName.split(' ')[1][0] }}
                                            </div>
                                        }
                                    }
                                </ng-template>
                            </wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Day of Week'"
                                [binding]="'dayOfWeek'"
                                [dataMap]="dayOfWeekMap"
                                [width]="140"
                            ></wj-flex-grid-column>
                        </wj-flex-grid>
                    </div>
                </div>
                @if (grid.selectedItem && canViewSelectedItem()) {
                    <div [hidden]="!grid.selectedItem" style="margin-top: 10px">
                        <ul
                            ngbNav
                            #nav="ngbNav"
                            [(activeId)]="active"
                            class="nav-tabs"
                            (activeIdChange)="tabChanged()"
                            style="margin-bottom: 10px"
                        >
                            <li [ngbNavItem]="1" [destroyOnHide]="false" [hidden]="!canEdit">
                                <a ngbNavLink>ROCKS</a>
                            </li>
                            <li [ngbNavItem]="2" [destroyOnHide]="false" [hidden]="!canEdit">
                                <a ngbNavLink>Metrics</a>
                            </li>
                            <li [ngbNavItem]="3" [destroyOnHide]="false" [hidden]="!canEdit">
                                <a ngbNavLink>To-Dos</a>
                            </li>
                            <li [ngbNavItem]="4" [destroyOnHide]="false" [hidden]="!canEdit">
                                <a ngbNavLink>Opportunities</a>
                            </li>
                            <li [ngbNavItem]="5" [destroyOnHide]="false" [hidden]="!canEdit">
                                <a ngbNavLink>Headlines</a>
                            </li>
                            <!-- <li [ngbNavItem]="6" [destroyOnHide]="false" [hidden]="!canEdit">
                                <a ngbNavLink>Stats</a>
                            </li> -->
                            <li [ngbNavItem]="7" [destroyOnHide]="false" [hidden]="!canEdit">
                                <a ngbNavLink>Agenda/Pages</a>
                            </li>
                        </ul>
                        @if (active === 1) {
                            <app-rocks
                                [meetingId]="grid.selectedItem?.id"
                                [meetings]="grid.items"
                                [meeting]="grid.selectedItem"
                            ></app-rocks>
                        }

                        @if (active === 2) {
                            <app-goals [meetingId]="grid.selectedItem?.id"></app-goals>
                        }

                        @if (active === 3) {
                            <app-to-dos
                                [meetingId]="grid.selectedItem?.id"
                                [meetings]="grid.items"
                                [meeting]="grid.selectedItem"
                            ></app-to-dos>
                        }

                        @if (active === 4) {
                            <app-headlines
                                [meetingId]="grid.selectedItem?.id"
                                [meetings]="grid.items"
                                [meeting]="grid.selectedItem"
                                [isHeadline]="false"
                            ></app-headlines>
                        }

                        @if (active === 5) {
                            <app-headlines
                                [meetingId]="grid.selectedItem?.id"
                                [meetings]="grid.items"
                                [meeting]="grid.selectedItem"
                                [isHeadline]="true"
                            ></app-headlines>
                        }

                        @if (active === 7) {
                            <app-meeting-pages [meetingId]="grid.selectedItem?.id" [active]="active"></app-meeting-pages>
                        }
                    </div>
                } @else {
                    @if (!canViewSelectedItem()) {
                        <div class="alert alert-warning" role="alert">
                            <strong>Not a member of the selected meeting!</strong> You cannot view the details of the selected meeting.
                        </div>
                    } @else {
                        <div class="alert alert-info" role="alert">
                            <strong>Welcome to the Meetings page!</strong> Please select a meeting from the list above to view its details.
                        </div>
                    }
                }
            </div>
        </div>
    </div>
</div>
